// Third-party imports
import $ from 'jquery';

export function checkIfDoesNotExceedMaxQuantity(
    pdpQuantityInput,
    counterElement,
    displayedCounterValue,
    inputCounterValue
) {
    let args = {
        pdpQuantityInput: pdpQuantityInput,
        counterElement: counterElement,
        displayedCounterValue: displayedCounterValue, // Counter value pre input
        inputCounterValue: inputCounterValue, // Counter value post input
    };
    let quantityData = args.pdpQuantityInput.data('maxQuantity');
    // Check if the variant has a maximum quantity
    if (hasQuantity(quantityData)) {
        maxQuantityHandler(args);
    } else {
        nonInventoryTrackedHandler(args);
    }
}

// If the variant doesn't have a max and it's inventory is not tracked
// we still need to confirm that the user value is not <= 0 or if the value
// is valid, we hide the popup (if visible)
function nonInventoryTrackedHandler(args) {
    let popUpElement = getPopUpElement(args.counterElement);
    if (
        valueIsLessThanOrEqualZero(args.inputCounterValue) ||
        isNaN(args.inputCounterValue)
    ) {
        valueTooLowOrNaNHandler(args);
    } else if (args.inputCounterValue > 0) {
        hidePopUpElement(popUpElement);
        injectQuantityInShopifyQuantityInput(args);
    }
}

function maxQuantityHandler(args) {
    let maxQuantity = parseInt(args.pdpQuantityInput.data('maxQuantity'));
    let popUpElement = getPopUpElement(args.counterElement);
    if (
        valueIsLessThanOrEqualZero(args.inputCounterValue) ||
        isNaN(args.inputCounterValue)
    ) {
        valueTooLowOrNaNHandler(args);
    } else if (
        valueIsSuperiorToMaxQuantity(args.inputCounterValue, maxQuantity)
    ) {
        let maxQtyText = popUpElement.data('maxQtyText');
        maxQtyText = `${maxQtyText} ${maxQuantity}`;
        makePopUpElementVisibile(popUpElement, maxQtyText);
        // If the value in the counter is more than the max, but we're trying to reduce the value
        if (args.inputCounterValue < args.displayedCounterValue) {
            injectQuantityInShopifyQuantityInput(args);
        }
    } else if (
        valueIsUnderOrEqualToMaxQuantity(args.inputCounterValue, maxQuantity)
    ) {
        injectQuantityInShopifyQuantityInput(args);
        hidePopUpElement(popUpElement);
    } else if (variantIdSelectedAndMaxQuantityIsZero(maxQuantity)) {
        let soldOutText = popUpElement.data('soldOutText');
        makePopUpElementVisibile(popUpElement, soldOutText);
    }
}

// If counter value is <= 0 or is Not a Number
function valueTooLowOrNaNHandler(args) {
    let popUpElement = getPopUpElement(args.counterElement);
    let minQtyText = popUpElement.data('minQtyText');
    makePopUpElementVisibile(popUpElement, minQtyText);
    // If the value in the counter is less than 0, but we're trying to increase the value
    if (
        args.inputCounterValue === 0 ||
        args.inputCounterValue > args.displayedCounterValue
    ) {
        injectQuantityInShopifyQuantityInput(args);
    }
}

function valueIsUnderOrEqualToMaxQuantity(inputCounterValue, maxQuantity) {
    return inputCounterValue <= maxQuantity;
}

function valueIsSuperiorToMaxQuantity(inputCounterValue, maxQuantity) {
    // Only need to check if inputCounterValue is greater than maxQuantity
    return inputCounterValue > maxQuantity;
}

function valueIsLessThanOrEqualZero(inputCounterValue) {
    return inputCounterValue <= 0;
}

function variantIdSelectedAndMaxQuantityIsZero(maxQuantity) {
    let selectedVariantId = $('.js-variantID-hook').val();
    return selectedVariantId && maxQuantity === 0;
}

function getPopUpElement(counterElement) {
    let popUpElement = $(counterElement)
        .parents('.js-checkboxPopUp-wrapper')
        .find('.js-checkboxPopUp-popUpWrapper');
    return popUpElement;
}

export function makePopUpElementVisibile(popUpElement, message) {
    let popupText = popUpElement.find('.checkboxPopUp-text');
    popupText.text(message);
    popupText.attr('role', 'alert');
    $(popUpElement).addClass('js-checkboxPopUp-visible');
    let closeButton = popUpElement.find('.checkboxPopUp-closeButton');
    closeButton.attr('tabindex', '0');
}

function hasQuantity(maxQuantity) {
    if (maxQuantity === 'doesNotApply') return false;
    return true;
}

export function popUpClosingEventHandler() {
    $('.js-checkboxPopUp-closeButton').on('click', function() {
        let popUpElement = $(this).parents('.js-checkboxPopUp-popUpWrapper');
        hidePopUpElement(popUpElement);
        $(this).attr('tabindex', '-1');
    });
}

function hidePopUpElement(popUpElement) {
    $(popUpElement).removeClass('js-checkboxPopUp-visible');
}

function injectQuantityInShopifyQuantityInput(args) {
    args.pdpQuantityInput.val(args.inputCounterValue);
    args.counterElement.val(args.inputCounterValue);
}
